import { useRouter } from 'next/router'
import type { ReactElement } from 'react'
import { createContext, useContext } from 'react'

type Props = {
  children: ReactElement
}

const BrandContext = createContext('toyota')

const BrandProvider = ({ children }: Props) => {
  const router = useRouter()
  // Should never be undefined as comes from next.config.js
  const initialState = router.locale ?? 'toyota'

  return (
    <BrandContext.Provider value={initialState}>
      {children}
    </BrandContext.Provider>
  )
}

const useBrand = () => {
  return useContext(BrandContext)
}

export { BrandProvider, useBrand }
